var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-item"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"light","content":"直購","placement":"top"}}),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.openProdbuy}},[_c('img',{attrs:{"src":require("../../assets/contract.png"),"width":"24","height":"24"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b6aa47e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SalesTool/Prodbuy.vue
// module id = null
// module chunks = 